export const loginImages = [
  "/images/login1.png",
  "/images/login2.png",
  "/images/login3.png",
  "/images/login4.png",
];

export const mypageImages = [
  "/images/mypage1.png",
  "/images/mypage2.png",
  "/images/mypage3.png",
];

export const sessionImages = ["/images/session1.png", "/images/session2.png"];

export const fumufumuImages = [
  "/images/fumufumu1.png",
  "/images/fumufumu2.png",
  "/images/fumufumu3.png",
];

export const closetImages = ["/images/closet1.png", "/images/closet2.png"];

export const clubroomImages = [
  "/images/clubroom1.png",
  "/images/clubroom2.png",
  "/images/clubroom3.png",
];

export const mapImages = [
  "/images/map1.png",
  "/images/map2.png",
  "/images/map3.png",
];

export const memberlistImages = [
  "/images/memberlist1.png",
  "/images/memberlist2.png",
  "/images/memberlist3.png",
];

export const rankingImages = ["/images/ranking1.png", "/images/ranking2.png"];

export const statusImages = [
  "/images/status1.png",
  "/images/status2.png",
  "/images/status3.png",
  "/images/status4.png",
];

export const missionImages = [
  "/images/mission1.png",
  "/images/mission2.png",
  "/images/mission3.png",
  "/images/mission4.png",
];

export const badgeImages = [
  "/images/badge1.png",
  "/images/badge2.png",
  "/images/badge3.png",
];

export const shopImages = ["/images/shop1.png", "/images/shop2.png"];

export const styleImages = ["/images/style1.png", "/images/style2.png"];
